import { BsIncognito } from 'react-icons/bs';

import { Avatar } from '../avatar';

const ICON_SIZE = { sm: 'size-4', md: 'size-5', lg: 'size-6' } as const;

/** Colour from the name; an anonymous patient (public link) gets the dark neutral one with an incognito icon. */
export function PatientAvatar({
  name,
  size = 'md',
  className,
}: {
  name: string;
  size?: keyof typeof ICON_SIZE;
  className?: string;
}) {
  return name ? (
    <Avatar name={name} size={size} tone="auto" className={className} />
  ) : (
    <Avatar
      name="Anonyme"
      size={size}
      tone="neutral"
      icon={<BsIncognito className={ICON_SIZE[size]} />}
      className={className}
    />
  );
}
